









































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Schedules, Props, User, Global, Errors } from '@/store';
import { Prop, Watch } from 'vue-property-decorator';
import CurveChart from './CurveChart.vue';
import API, { Types } from '@/modules/API';
import PropUtils from '@/modules/PropUtils';
import Utils from '@/modules/Utils';
import { Curve, VTextFieldRef } from '@/modules/Types';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import PropEditor from '@/components/PropEditor.vue';
import DaliDimmingInfo from '@/pages/curves/DaliDimmingInfo.vue';

@Component({
  components: {
    CurveChart,
    PropEditor,
    DaliDimmingInfo
  }
})
class NewCurve extends Vue {
  @Global.State('lang') lang;
  @Global.State('timezone') projectTimezone;
  @Global.State('dusk_dawn_data') dusk_dawn_data;
  @Errors.State('error') error;
  @Schedules.Action('changeCurve') changeCurve;
  @Schedules.Action('runSchedulerInServer') runSchedulerInServer;
  @Schedules.State('userCurves') userCurves;
  @User.State('project') project;
  @Props.State('list') projectProperties;
  
  @Prop() dataCurve;
  @Prop() dialog;
  @Prop() setCurveClicked;
  @Prop() setActiveCurveData;
  @Prop() updateSelctedCurves;
  @Prop() curves_map;
  @Prop() preview;
  @Prop() setPreview;

  colors = ['blue', 'red', 'yellow', 'green', 'purple', 'black', 'grey', 'pink', '#22A699', '#E893CF', '#4942E4', '#99627A', '#3C486B', '#EA906C', '#B3C890'];
  // The named presets as Vuetify renders them, so a curve stored by name shows the same
  // colour in the picker as it does on its chip.
  NAMED_COLORS_HEX = {
    blue: '#2196F3',
    red: '#F44336',
    yellow: '#FFEB3B',
    green: '#4CAF50',
    purple: '#9C27B0',
    black: '#000000',
    grey: '#9E9E9E',
    pink: '#E91E63'
  };

  // Every preset, by both the name it can be stored under and its hex, so the picker
  // can say 'Teal' instead of '#22A699' whichever form the curve holds.
  COLOR_NAMES = {
    blue: 'Blue', '#2196F3': 'Blue',
    red: 'Red', '#F44336': 'Red',
    yellow: 'Yellow', '#FFEB3B': 'Yellow',
    green: 'Green', '#4CAF50': 'Green',
    purple: 'Purple', '#9C27B0': 'Purple',
    black: 'Black', '#000000': 'Black',
    grey: 'Grey', '#9E9E9E': 'Grey',
    pink: 'Pink', '#E91E63': 'Pink',
    '#22A699': 'Teal',
    '#E893CF': 'Light Pink',
    '#4942E4': 'Indigo',
    '#99627A': 'Plum',
    '#3C486B': 'Navy',
    '#EA906C': 'Coral',
    '#B3C890': 'Olive'
  };

  DEFAULT_COLOR_HEX = '#2196F3';
  color_menu = false;
  chart_datasets = [];
  chart_labels = [];
  name = '';
  description = '';
  timezone = '';
  originalTimezoneDatasets = [];
  offset = 0;
  duskDawnProperty = null;
  duskPowerLevel = 100;
  dawnPowerLevel = 100;
  duskOffset = 0;
  dawnOffset = 0;
  loading = true;
  minDuskIndex = null;
  minDawnIndex = null;
  maxDuskIndex = null;
  maxDawnIndex = null;
  startDuskOffset = null;
  startDawnOffset = null;
  endDuskOffset = null;
  endDawnOffset = null;
  duskSteps = 0;
  dawnSteps = 0;
  showDuskDawnOptions = false;
  originalStart = '';
  turnOn = '';
  turnOff = '';
  duskDawnWindowColor: '#DCDCDC';
  sunriseTimeStart = '';
  duskStart = '';
  sunsetTimeStart = '';
  dawnStart = '';
  $refs!: { 
    propEditor: InstanceType<typeof PropEditor>,
    curveChart: Vue & { getDatasets: () => number[] },
    curve_name: VTextFieldRef
  };

  curve: Curve = {
    id: '',
    name: '',
    description: '',
    start: {
      type: 'none',
      offset: 0,
      duration: '0',
      power: 100
    },
    end: {
      type: 'none',
      offset : 0,
      duration: '0',
      power: 100
    },
    color: 'blue',
    datasets: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    labels: [],
    timezone: ''
  };

  created() {
    this.setDuskDawnProperty();
    this.initializeDatasets();
    this.$nextTick(() => {
      this.updateChartTimes();
    });
  }

  mounted(){
    // The chart follows its own box (see CurveChart.observeChartBox), so nothing here has
    // to tell it that the dialog it was drawn in has settled.
    if (!this.preview) this.$refs.curve_name.focus();
  }

  setDuskDawnProperty(){
    this.duskDawnProperty = PropUtils.getProperty(this.projectProperties, 'project.dusk_dawn_min_max_yearly');
    this.duskDawnProperty = this.duskDawnProperty ? this.duskDawnProperty.value : null;
    if (!this.duskDawnProperty){
      const message = 'There is no dusk dawn property in this project. Please contact with support team.';
      Utils.showNotify('error', 'Error!', message);
    }
  }

  initializeDatasets(){
    if (this.dataCurve && Object.keys(this.dataCurve).length > 0)
      this.curve = cloneDeep({...this.dataCurve});

    this.originalStart = this.curve.start.type;
  }

  updateChartTimes(){
    this.offset = this.getTimezoneOffset(); 
    this.calculateSunData();
    this.calculateMinMaxDuskDawn(); // calculate according to timezone offset
    this.updateDuskDawnByWindowOffset(); // calculate according to windows offset

    // curve datasets are stored in the project's local time, so they are drawn as they are
    this.originalTimezoneDatasets = [...this.curve.datasets];
    this.setCurveToDashboard();
    if (this.curve.start.type === 'dusk') this.showDuskDawnOptions = true;
  }

  updateDuskDawnByWindowOffset(){
    if (this.duskDawnProperty){
      this.setPowerAndOffset();
      this.updateDuskOffset();
      this.updateDawnOffset();
    }
  }

  calculateSunData() {
    try {
      this.setDuskDawnByTimezone();
    } catch (error) {
      console.log('Error while converting Sun Data:', error);
      this.clearSunData();
    }
  }

  setDuskDawnByTimezone(){
    this.sunriseTimeStart = this.dusk_dawn_data.sunrise.format(this.time_format);
    this.sunsetTimeStart = this.dusk_dawn_data.sunset_start.format(this.time_format);
    this.duskStart = this.dusk_dawn_data.dusk.format(this.time_format);
    this.dawnStart = this.dusk_dawn_data.dawn.format(this.time_format);
    this.setTurnOnOff();
  }

  /*
    The hours the light actually switches at today: dusk and dawn moved by the curve's
    offsets. Same calculation, through the same helper, as the Schedule tab of a fixture
    (tondoTabs/CurveTab.setTurnOnOff) - the grey windows on the chart cannot say this,
    they span every dusk of the year in half hour steps.
  */
  setTurnOnOff(){
    if (!this.dusk_dawn_data) return;
    this.turnOn = Utils.getAstronomicalTimeByMinutesOffset(
      this.duskOffset, this.dusk_dawn_data.dusk_timestamp, this.dusk_dawn_data.dusk, this.projectTimezone, this.time_format
    );
    this.turnOff = Utils.getAstronomicalTimeByMinutesOffset(
      this.dawnOffset, this.dusk_dawn_data.dawn_timestamp, this.dusk_dawn_data.dawn, this.projectTimezone, this.time_format
    );
  }

  /*
    Times are written the way the project's own region writes them - 24 hour in Israel,
    AM/PM where that is the convention - rather than always AM/PM. Shared by the sun
    times, the chart's hour labels and the curve points read off them.
  */
  get time_format(){
    return Utils.getTimeFormat(this.projectTimezone);
  }

  clearSunData(){
    this.sunriseTimeStart = '';
    this.duskStart = '';
    this.sunsetTimeStart = '';
    this.dawnStart = '';
  }

  // initializeTimezoneNames(){
  //   momentZ.tz.load({
  //     zones: [],
  //     links: [],
  //     version: '2019c'
  //   });
  //   this.timezoneNames = momentZ.tz.names();
  //   this.timezoneNames = this.timezoneNames.filter(
  //     (e) =>
  //       !e.includes('GMT') &&
  //       !e.includes('UTC') &&
  //       !e.includes('Universal') &&
  //       !e.includes('ROK') &&
  //       !e.includes('ROC') &&
  //       !e.includes('UCT') &&
  //       !e.includes('W-SU') &&
  //       !e.includes('WET') &&
  //       !e.includes('Zulu') &&
  //       !e.includes('MST') &&
  //       !e.includes('MET') &&
  //       !e.includes('NZ') &&
  //       !e.includes('PRC') &&
  //       !e.includes('PST') 
  //     );
  // }

  setCurveToDashboard() {
    if (this.originalStart === 'dusk') {
      if (this.duskDawnProperty) this.removeServerDuskDawnSign(); // remove dusk(-1) dawn(-2) server sign from timezone datasets
      this.showDuskDawnOptions = true;
    }else {
      this.showDuskDawnOptions = false;
    }
    this.loading = false;
  }

  removeServerDuskDawnSign(){
    this.setWindowsLocationByOffset(this.originalTimezoneDatasets);
    this.unsignDuskDawnWindow(this.originalTimezoneDatasets, this.startDuskOffset, this.endDuskOffset, this.startDawnOffset, this.endDawnOffset, this.duskPowerLevel, this.dawnPowerLevel);
  }

  setPowerAndOffset(){
    this.duskPowerLevel = +this.curve.start.power;
    this.duskOffset = +this.curve.start.offset;
    this.dawnPowerLevel = +this.curve.end.power;
    this.dawnOffset = +this.curve.end.offset;
  }

  // project.dusk_dawn_min_max_yearly is kept in UTC, so its times are moved by this offset
  // to find their slots in the local time chart
  getTimezoneOffset() {
    try {
      const new_offset = moment().tz(this.projectTimezone).utcOffset();
      const remain = Math.abs(new_offset) % 60;
      let roundedRemain = remain >= 16 && remain <= 45 ? 0.5 : 0; 
      roundedRemain = new_offset < 0 ? -roundedRemain : roundedRemain;
      let offsetInHours = new_offset < 0 ? Math.ceil(new_offset / 60) : Math.floor(new_offset / 60);
      offsetInHours = remain >= 46 && remain <= 59 ? offsetInHours > 0 ? offsetInHours + 1 : offsetInHours - 1 : offsetInHours;
      return offsetInHours + roundedRemain;
    } catch (error) {
      console.log('error, while calculate offset', error);
      return 0;
    }
  }

  calculateMinMaxDuskDawn(){
    if (this.duskDawnProperty){
      const minDusk = this.duskDawnProperty['min dusk'];
      const maxDusk = this.duskDawnProperty['max dusk'];
      const minDawn = this.duskDawnProperty['min dawn'];
      const maxDawn = this.duskDawnProperty['max dawn'];

      this.calculateMinIndex(minDusk, 'dusk');
      this.calculateMinIndex(minDawn, 'dawn');
      this.calculateMaxIndex(maxDusk, 'dusk');
      this.calculateMaxIndex(maxDawn, 'dawn');
    }
  }

  calculateMinIndex(time, type) {
    let [hour, minutes] = time.split(':');
    hour = `${+hour + this.offset}`;
    minutes = minutes > 30 ? '30' : '00';
    const decimalHour = this.timeToDecimal(hour, minutes);
    const minIndex = decimalHour > 12 ? (decimalHour - 12) * 2 : (decimalHour + 12) * 2;
    type === 'dusk' ? this.minDuskIndex = minIndex : this.minDawnIndex = minIndex;
  }

  calculateMaxIndex(time, type) {
    let [hour, minutes] = time.split(':');

    hour = minutes > 30 ? `${+hour + 1}` : hour;
    hour = `${+hour + this.offset}`;
    minutes = minutes > '00' && minutes <= '30' ? '30' : '00';

    const decimalHour = this.timeToDecimal(hour, minutes);
    const maxIndex = decimalHour > 12 ? (decimalHour - 12) * 2 : (decimalHour + 12) * 2;
    type === 'dusk' ? this.maxDuskIndex = maxIndex : this.maxDawnIndex = maxIndex;
  }

  timeToDecimal(hour, minutes) {
    return minutes === '30' ? +hour + 0.5 : +hour;
  }

  updateEndType(type){
    this.curve.end.type = type;
    this.showDuskDawnOptions = type === 'dawn';
  }

  updateStartType(type){
    this.curve.start.type = type;
    this.showDuskDawnOptions = type === 'dusk';
  }

  save() {
    if (this.$refs.curve_name.validate()) {
      const finalCurve = this.setCurveToServer();
      this.changeCurve(finalCurve);
      this.saveCurveProperty(finalCurve);
    }
  }

  isCurveNameExists(){
    return this.userCurves.some((curve) => curve.name === this.curve.name && curve.id !== this.curve.id);
  }

  /*
    Inside the schedule flow the editor is a dialog the step owns, so closing it is the
    step's business. On its own route (/curves/:id, /curves/create) there is no owner and
    nothing to hand control back to, so it returns to the Curves Management page.
  */
  close(){
    typeof this.setCurveClicked === 'function'
      ? this.setCurveClicked(false)
      : this.$router.push('/curves');
  }

  /* The schedule step drives the dialog through `dialog`; on its own route it is the page. */
  get is_open(){
    return this.dialog === undefined ? true : this.dialog;
  }

  /* An existing curve was handed in, as opposed to an empty one being built. */
  get is_edit_mode(){
    return !!this.dataCurve && Object.keys(this.dataCurve).length > 0;
  }

  /* Read in the order the night runs: sunset, dusk, dawn, sunrise. */
  get sun_times(){
    return [
      { label: 'Sunset', value: this.sunsetTimeStart, icon: 'mdi-weather-sunset-down' },
      { label: 'Dusk', value: this.duskStart, icon: 'mdi-weather-night' },
      { label: 'Dawn', value: this.dawnStart, icon: 'mdi-weather-sunset-up' },
      { label: 'Sunrise', value: this.sunriseTimeStart, icon: 'mdi-white-balance-sunny' }
    ];
  }

  setChartDatasets({ data, labels }){
    this.chart_datasets = data;
    this.chart_labels = labels;
  }

  /*
    The 48 half-hour bars read back as the time ranges they amount to: consecutive bars
    holding the same dim level are one point, which is how the curve is actually meant
    to be read. Derived rather than stored - the chart stays the single source of truth.
  */
  get curve_points(){
    if (!this.chart_datasets.length || !this.chart_labels.length) return [];

    const points = [];
    this.chart_datasets.forEach((value, index) => {
      const previous = points[points.length - 1];
      previous && previous.value === value
        ? previous.to = this.getSlotEndLabel(index)
        : points.push({ value, from: this.chart_labels[index], to: this.getSlotEndLabel(index) });
    });

    /*
      The day is drawn from noon to noon, so a stretch that runs across midday is split
      between the end and the start of the array and would be listed twice. The last run
      ends exactly where the first begins, so when they hold the same level they are one
      period: it is reported once, from the evening side.
    */
    if (points.length > 1) {
      const first = points[0];
      const last = points[points.length - 1];
      if (first.value === last.value) {
        points.pop();
        points[0] = { value: first.value, from: last.from, to: first.to };
      }
    }

    return points;
  }

  /* A bar covers the half hour that starts at its label, so it ends at the next one. */
  getSlotEndLabel(index){
    return this.chart_labels[(index + 1) % this.chart_labels.length];
  }

  /*
    Only the hours the light is actually on. The 0% stretches are the gaps between them
    and are covered by the note under the list, which keeps it to the few lines that say
    something - a curve is mostly off.
  */
  get lit_curve_points(){
    const points = this.curve_points.filter((point) => point.value > 0);
    if (!this.showDuskDawnOptions || !points.length) return points;

    /*
      In dusk/dawn mode the chart can only draw the window in half hour slots, and that
      window covers every dusk of the year - so its edges read as 17:30 - 08:00 while the
      light actually switches at today's dusk and dawn plus the offsets. Where a point
      does start or end on a window edge, it is reported as the real time instead. A
      point that begins later (the dusk window dimmed to 0%) keeps its own slot.
    */
    const dusk_edge = this.chart_labels[this.startDuskOffset];
    const dawn_edge = this.chart_labels[this.endDawnOffset];
    const last_index = points.length - 1;

    return points.map((point, index) => ({
      ...point,
      from: index === 0 && this.turnOn && point.from === dusk_edge ? this.turnOn : point.from,
      to: index === last_index && this.turnOff && point.to === dawn_edge ? this.turnOff : point.to
    }));
  }

  convertPowerAndOffsetToString(curve){
    curve.start.power = this.curve.start.type === 'dusk' && this.duskDawnProperty ? this.duskPowerLevel.toString() : '100';
    curve.end.power = this.curve.start.type === 'dusk' && this.duskDawnProperty ? this.dawnPowerLevel.toString() : '100';
    curve.start.offset = this.curve.start.type === 'dusk' && this.duskDawnProperty ? this.duskOffset.toString() : '0';
    curve.end.offset = this.curve.start.type === 'dusk' && this.duskDawnProperty ? this.dawnOffset.toString() : '0';
  }

  setCurveToServer(){
    const finalCurve = cloneDeep({...this.curve});
    this.convertPowerAndOffsetToString(finalCurve);
    if (!this.dataCurve) finalCurve.id = '_' + Math.random().toString(36).substr(2, 9);
    const finalDatasets = this.$refs.curveChart.getDatasets();

    if (this.curve.start.type === 'dusk'){
      if (this.duskDawnProperty){
        this.signDuskDawnWindow(finalDatasets, this.startDuskOffset, this.endDuskOffset, this.startDawnOffset, this.endDawnOffset);
      }else{
        finalCurve.start.type = 'none';
        finalCurve.end.type = 'none';
      }
    }
    finalCurve.datasets = finalDatasets; // saved in the project's local time
    return finalCurve;
  }

  signDuskDawnWindow(datasets, startDusk, endDusk, startDawn, endDawn){
    this.signWindow(datasets, startDusk, endDusk, -1);
    this.signWindow(datasets, startDawn, endDawn, -2);
  }

  setWindowsLocationByOffset(datasets){
    this.setDuskDawnLocationByOffset(datasets, -1);
    this.setDuskDawnLocationByOffset(datasets, -2);
  }

  unsignDuskDawnWindow(datasets, startDusk, endDusk, startDawn, endDawn, duskPower, dawnPower){
    this.signWindow(datasets, startDusk, endDusk, duskPower); // sign window with original dusk dawn offset
    this.signWindow(datasets, startDawn, endDawn, dawnPower); // sign window with original dusk dawn offset
  }

  signWindow(datasets, start, end, value){
    if (start > end){
      for (let i = start; i < 48; i++)
        datasets[i] = value;
      for (let i = 0; i < end; i++)
        datasets[i] = value;
    }else{
      for (let i = start; i < end; i++)
        datasets[i] = value;
    }
  }

  setDuskDawnLocationByOffset(datasets, value){
    const [start, end] = this.getStartEndIndex(datasets, value);
    value === -1 ? this.startDuskOffset = start : this.startDawnOffset = start;
    value === -1 ? this.endDuskOffset = end + 1 : this.endDawnOffset = end + 1;
  }

  getStartEndIndex(datasets, value){
    return [datasets.indexOf(value), datasets.lastIndexOf(value)];
  }

  @Watch('duskOffset')
  onDuskOffsetChanged(){
    if (this.duskDawnProperty) {
      this.updateDuskOffset();
      this.setTurnOnOff();
    }
  }

  updateDuskOffset(){
    this.duskSteps = this.calculateWindowOffset(this.duskOffset);
    this.startDuskOffset = this.calculateIndexInRange(this.minDuskIndex + this.duskSteps);
    this.endDuskOffset = this.calculateIndexInRange(this.maxDuskIndex + this.duskSteps);
  }

  @Watch('dawnOffset')
  onDawnOffsetChanged(){
    if (this.duskDawnProperty){
      this.updateDawnOffset();
      this.setTurnOnOff();
    } 
  }

  updateDawnOffset(){
    this.dawnSteps = this.calculateWindowOffset(this.dawnOffset);
    this.startDawnOffset = this.calculateIndexInRange(this.minDawnIndex + this.dawnSteps);
    this.endDawnOffset = this.calculateIndexInRange(this.maxDawnIndex + this.dawnSteps);
  }

  calculateWindowOffset(offset){
    const positiveOffset = Math.abs(offset);
    const remain = positiveOffset % 60;
    let hours = Math.floor(positiveOffset / 60);
    hours = remain > 30 ? hours + 1 : hours;
    const roundedMinutes = remain > 30 || remain === 0 ? 0 : 0.5;
    const roundedOffsetInHours = (hours + roundedMinutes) * 2;
    return offset < 0 ? -roundedOffsetInHours : roundedOffsetInHours;
  }

  saveCurveProperty(finalCurve) {
    this.$refs.propEditor.save(this.userCurves, {
      name: 'dashboard.curves',
      objectID: this.project.id,
      objectType: Types.PROJECTS
    }, () => { 
      this.close(); 
      if (this.dataCurve) this.runSchedulerInServer();
      // Only the schedule step has a curve selection to keep in sync.
      if (typeof this.updateSelctedCurves === 'function' && this.curves_map) {
        this.updateSelctedCurves([this.curves_map.get(finalCurve.id)]);
      }
      if (typeof this.setActiveCurveData === 'function') {
        this.setActiveCurveData({id: finalCurve.id, color: finalCurve.color});
      }
    }, 'Curve Updated Successfully');

  }

  setColor(color) {
    this.curve.color = color;
  }

  /*
    Picking a preset is a finished choice, so the menu closes - unlike the custom picker,
    which fires on every step of the browser's colour dialog and has to leave it open.
  */
  selectColor(color) {
    this.setColor(color);
    this.color_menu = false;
  }

  /* The hex a colour resolves to, whether it is stored as a name or as a hex. */
  hexOf(color) {
    if (!color) return this.DEFAULT_COLOR_HEX;
    return (color.startsWith('#') ? color : this.NAMED_COLORS_HEX[color] || color).toUpperCase();
  }

  /*
    The colour's name, which is what the user picks by - the hex is shown next to it
    for anyone who needs the exact value. A colour chosen through the picker has no
    name, so it reads as 'Custom Color'.
  */
  colorName(color) {
    const name = this.COLOR_NAMES[color] || this.COLOR_NAMES[this.hexOf(color)];
    return this.$t(name || 'Custom Color');
  }

  /*
    The colour of a curve saved before the picker existed is a name ('blue', 'green'),
    which a native colour input cannot show - it only speaks hex. Resolved to the
    matching palette hex for display, while the stored value is left alone until the
    user actually picks something else.
  */
  get color_hex() {
    const color = this.curve.color || '';
    if (color.startsWith('#')) return color;
    return this.NAMED_COLORS_HEX[color] || this.DEFAULT_COLOR_HEX;
  }

  /* A preset is the current colour whether it is stored by name or as its hex. */
  isSelectedColor(color) {
    if (this.curve.color === color) return true;
    const preset_hex = color.startsWith('#') ? color : this.NAMED_COLORS_HEX[color];
    return !!preset_hex && preset_hex.toLowerCase() === this.color_hex.toLowerCase();
  }

  calculateIndexInRange(index){
    return index < 0 ? 48 + index : index >= 48 ? index - 48 : index;
  }
}

export default NewCurve;
